import {
  ADD_FAVORITE,
  SET_FAVORITE_LOADING,
  SET_FAVORITE_ERROR
} from '../actionTypes'

export function addFavorite(input) {
  return {
    type: ADD_FAVORITE,
    payload: input
  }
}

export function setFavoriteLoading(input) {
  return {
    type: SET_FAVORITE_LOADING,
    payload: input
  }
}

export function setFavoriteError(input) {
  return {
    type: SET_FAVORITE_ERROR,
    payload: input
  }
}